import { Component, Inject, OnInit, Optional, Input } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormFieldDirective } from "../form-field";
import { FormFieldType } from "../form-field.model";

@Component({
    selector: "tc-masked-field",
    templateUrl: "./masked-field.component.html",
    styleUrls: ["./masked-field.component.scss"],
    standalone: false
})
export class MaskedFieldComponent extends FormFieldDirective implements OnInit {
	// Input Variables
	@Input() displayTooltip: boolean;
	@Input() tooltipText: string;
	@Input() mask: string;
	@Input() removeHintSpace: boolean = false;

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		formGroupDirective: FormGroupDirective
	) {
		super(formGroupDirective);
	}

	ngOnInit(): void {
		this.type = FormFieldType.MASKED;
	}
}
